import { endpoints } from 'src/config/endpoints';
// The list of file replacements can be found in `angular.json`.
const api = 'https://verum-api-dev-fbfwerbpaxhkdpen.westus2-01.azurewebsites.net';

export const environment = {
	production: false,
	blockchainVerifyUrl: 'https://local.bloks.io/transaction',
	blockchainVerifyUrlParams: '?nodeUrl=http%3A%2F%2Fjungle4.cryptolions.io',
	...endpoints(api),
};
